import React, { Component } from "react";
import {
  Segment,
  Header,
  Container,
  Form,
  Dropdown,
  Grid,
  Message,
  Icon,
  Button,
} from "semantic-ui-react";
import { connect } from "react-redux";
import {
  updateEmailAddress,
  updateFirstName,
  updateLastName,
  updateTimezone,
  updateLearningInstitution,
  updateHideSuccess,
  updateHideError,
  updateProvince,
  updatePhone,
  updateBirthday,
  updateStreetAddress,
  updatePostalCode,
  updateCity,
} from "./../reducers/accountDetails";
import { updateUser } from "./../lib/keycloakServices";
import { createOrUpdateUser } from "./../lib/userServices";
import { fetchClients } from "./../reducers/clients";
import { addNotification } from "./../reducers/notification";
import { updateKeycloak } from "./../reducers/keycloak";
import PictureUploader from "../components/PictureUploader";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

class AccountDetails extends Component {
  constructor(props) {
    super(props);
    this.handleUpdateEmailAddress = this.handleUpdateEmailAddress.bind(this);
    this.handleUpdateLastName = this.handleUpdateLastName.bind(this);
    this.handleUpdateFirstName = this.handleUpdateFirstName.bind(this);
    this.handleUpdateTimezone = this.handleUpdateTimezone.bind(this);
    this.handleUpdatePostalCode = this.handleUpdatePostalCode.bind(this);
    this.handleUpdateCity = this.handleUpdateCity.bind(this);
    this.handleUpdateStreetAddress = this.handleUpdateStreetAddress.bind(this);
    this.handleUpdatePhone = this.handleUpdatePhone.bind(this);
    this.handleUpdateBirthday = this.handleUpdateBirthday.bind(this);
    this.handleUpdateLearningInstitution =
      this.handleUpdateLearningInstitution.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    this.props.fetchClients();
    console.debug("Fetched clients:", this.props.clients.clients);
    this.props.updateEmailAddress(this.props.kc.tokenParsed.email);
    this.props.updateLastName(this.props.kc.tokenParsed.family_name);
    this.props.updateFirstName(this.props.kc.tokenParsed.given_name);
    this.props.updateTimezone(this.props.kc.tokenParsed.timezone);
    this.props.updateProvince(this.props.kc.tokenParsed.province);
    this.props.updateLearningInstitution(
      this.props.kc.tokenParsed.learning_institution
        ? String(this.props.kc.tokenParsed.learning_institution)
        : null
    );
    this.props.updatePhone(this.props.kc.tokenParsed.phone);
    // Normalize birthday to YYYY-MM-DD for the date input (Keycloak sends "January 1, 2011" format)
    const rawBirthday = this.props.kc.tokenParsed.birthday;
    let normalizedBirthday = "";
    if (rawBirthday) {
      const dateObj = new Date(rawBirthday);
      if (!isNaN(dateObj.getTime())) {
        const y = dateObj.getUTCFullYear();
        const m = String(dateObj.getUTCMonth() + 1).padStart(2, "0");
        const d = String(dateObj.getUTCDate()).padStart(2, "0");
        normalizedBirthday = `${y}-${m}-${d}`;
      }
    }
    this.props.updateBirthday(normalizedBirthday);
    this.props.updateStreetAddress(this.props.kc.tokenParsed.street);
    this.props.updateCity(this.props.kc.tokenParsed.city);
    this.props.updatePostalCode(this.props.kc.tokenParsed.postal_code);
  }
  handleUpdateEmailAddress(value) {
    console.debug("Email address changed:", value);
    this.props.updateEmailAddress(value);
  }
  handleUpdateFirstName(value) {
    console.debug("First name changed:", value);
    this.props.updateFirstName(value);
  }
  handleUpdateLastName(value) {
    console.debug("Last name changed:", value);
    this.props.updateLastName(value);
  }
  handleUpdateTimezone(value) {
    console.debug("Timezone changed:", value);
    this.props.updateTimezone(value);
  }
  handleUpdateLearningInstitution(value) {
    console.debug("Learning institution changed:", value);
    this.props.updateLearningInstitution(value);
  }
  handleUpdateProvince(value) {
    console.debug("Province changed:", value);
    this.props.updateProvince(value);
  }
  handleUpdatePhone(value) {
    console.debug("Phone changed:", value);
    this.props.updatePhone(value);
  }
  handleUpdateBirthday(value) {
    console.debug("Birthday changed:", value);
    this.props.updateBirthday(value);
  }
  handleUpdatePostalCode(value) {
    console.debug("Postal code changed:", value);
    this.props.updatePostalCode(value);
  }
  handleUpdateCity(value) {
    console.debug("City changed:", value);
    this.props.updateCity(value);
  }
  handleUpdateStreetAddress(value) {
    console.debug("Street address changed:", value);
    this.props.updateStreetAddress(value);
  }
  handleSubmit() {
    // Validate birthday format YYYY-MM-DD

    const birthday = this.props.accountDetails.birthday;
    const birthdayPattern = /^\d{4}-\d{2}-\d{2}$/;
    if (birthday && !birthdayPattern.test(birthday)) {
      this.props.addNotification({
        message: this.props.t("AccountDetails.invalidBirthdayFormat"),
        type: "error",
        title: this.props.t("AccountDetails.error"),
        timeout: true,
      });
      window.scroll(0, 0);
      return;
    }

    updateUser({
      id: this.props.kc.tokenParsed.sub,
      email: this.props.accountDetails.emailAddress,
      firstName: this.props.accountDetails.firstName,
      lastName: this.props.accountDetails.lastName,
      timezone: this.props.accountDetails.timezone,
      learningInstitution: this.props.accountDetails.learningInstitution,
      province: this.props.accountDetails.province,
      birthday: this.props.accountDetails.birthday,
      phone: this.props.accountDetails.phone,
      streetAddress: this.props.accountDetails.streetAddress,
      postalCode: this.props.accountDetails.postalCode,
      city: this.props.accountDetails.city,
    }).then((res) => {
      if (res.success) {
        console.log("User update succeeded:", res);
        let user = {
          user_id: this.props.kc.tokenParsed.sub,
          username: this.props.kc.tokenParsed.preferred_username,
          first_name: this.props.accountDetails.firstName,
          last_name: this.props.accountDetails.lastName,
          timezone: this.props.accountDetails.timezone,
          learning_institution: this.props.accountDetails.learningInstitution,
          province: this.props.accountDetails.province,
          dob: this.props.accountDetails.birthday,
          phone: this.props.accountDetails.phone,
        };
        user = Object.assign(user);
        createOrUpdateUser(user);
        this.props.addNotification({
          message: this.props.t("AccountDetails.updatingSuccess"),
          type: "success",
          title: this.props.t("AccountDetails.success"),
          timeout: true,
        });

        this.props.updateKeycloak({
          ...this.props.kc,
          tokenParsed: {
            ...this.props.kc.tokenParsed,
            family_name: this.props.accountDetails.lastName,
            given_name: this.props.accountDetails.firstName,
            timezone: this.props.accountDetails.timezone,
            province: this.props.accountDetails.province,
            learning_institution: this.props.accountDetails.learningInstitution,
          },
        });
      } else {
        console.error("User update failed:", res);
        this.props.addNotification({
          message: this.props.t("AccountDetails.updatingError"),
          type: "error",
          title: this.props.t("AccountDetails.error"),
          timeout: true,
        });
      }
      window.scroll(0, 0);
    });
  }
  render() {
    let clients = [];
    this.props.clients.clients.forEach((client) => {
      if (client.online === true) {
        clients.push({ value: `${client.id}`, text: client.organization_name });
      }
    });

    let timeZones = [
      { text: this.props.t("AccountDetails.PST"), value: "PST" },
      { text: this.props.t("AccountDetails.MST"), value: "MST" },
      { text: this.props.t("AccountDetails.CST"), value: "CST" },
      { text: this.props.t("AccountDetails.EST"), value: "EST" },
      { text: this.props.t("AccountDetails.AST"), value: "AST" },
      { text: this.props.t("AccountDetails.NST"), value: "NST" },
    ];

    let provinces = [
      { text: this.props.t("AccountDetails.ON"), value: "ON" },
      { text: this.props.t("AccountDetails.QC"), value: "QC" },
      { text: this.props.t("AccountDetails.PE"), value: "PE" },
      { text: this.props.t("AccountDetails.NB"), value: "NB" },
      { text: this.props.t("AccountDetails.NS"), value: "NS" },
      { text: this.props.t("AccountDetails.NL"), value: "NL" },
      { text: this.props.t("AccountDetails.MB"), value: "MB" },
      { text: this.props.t("AccountDetails.SK"), value: "SK" },
      { text: this.props.t("AccountDetails.AB"), value: "AB" },
      { text: this.props.t("AccountDetails.BC"), value: "BC" },
      { text: this.props.t("AccountDetails.NT"), value: "NT" },
      { text: this.props.t("AccountDetails.YT"), value: "YT" },
      { text: this.props.t("AccountDetails.NU"), value: "NU" },
    ];
    return (
      <div style={{ margin: 8 }}>
        <Container>
          <Segment>
            <Header>{this.props.t("AccountDetails.header")}</Header>

            {!this.props.kc.tokenParsed.learning_institution && (
              <Message warning icon style={{ marginBottom: "1em" }}>
                <Icon name="exclamation triangle" />
                <Message.Content>
                  {this.props.t("AccountDetails.completeProfileRequired")}
                </Message.Content>
              </Message>
            )}

            <Message info icon style={{ marginBottom: "2em" }}>
              <Icon name="info circle" />
              <Message.Content>
                <Message.Header>
                  {this.props.t("AccountDetails.whyWeNeedInfo")}
                </Message.Header>
                <p>
                  {this.props.t("AccountDetails.dataCollectionExplanation")}{" "}
                  <a
                    href="https://www.eproctorcanada.com/privacy-policy/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {this.props.t("AccountDetails.privacyPolicy")}
                  </a>
                </p>
              </Message.Content>
            </Message>

            <Form>
              <Grid stackable columns={2}>
                <Grid.Row>
                  {/* Left Column - Personal Information */}
                  <Grid.Column>
                    <Form.Field required>
                      <label>{this.props.t("general.emailAddress")}</label>
                      <input
                        disabled
                        value={this.props.accountDetails.emailAddress || ""}
                        onChange={(e) =>
                          this.handleUpdateEmailAddress(e.target.value)
                        }
                      />
                    </Form.Field>

                    <Form.Group widths="equal">
                      <Form.Input
                        fluid
                        required
                        label={this.props.t("general.lastName")}
                        value={this.props.accountDetails.lastName}
                        onChange={(e) => this.handleUpdateLastName(e.target.value)}
                      />
                      <Form.Input
                        fluid
                        required
                        label={this.props.t("general.firstName")}
                        value={this.props.accountDetails.firstName}
                        onChange={(e) => this.handleUpdateFirstName(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Field>
                      <label>{this.props.t("general.phoneNumber")}</label>
                      <input
                        type="tel"
                        value={this.props.accountDetails.phone || ""}
                        onChange={(e) => this.handleUpdatePhone(e.target.value)}
                        placeholder="(123) 456-7890"
                        pattern="[\(]?[0-9]{3}[\)]?[\s\-]?[0-9]{3}[\s\-]?[0-9]{4}"
                        title="Please enter a valid phone number (e.g., (123) 456-7890 or 123-456-7890)"
                      />
                    </Form.Field>

                    <Form.Field>
                      <label>{this.props.t("AccountDetails.dateOfBirth")}</label>
                      <input
                        type="date"
                        value={this.props.accountDetails.birthday || ""}
                        onChange={(e) => this.handleUpdateBirthday(e.target.value)}
                        pattern="\d{4}-\d{2}-\d{2}"
                        placeholder="YYYY-MM-DD"
                      />
                    </Form.Field>
                  </Grid.Column>

                  {/* Right Column - Location & Institution */}
                  <Grid.Column>
                    <Form.Field required>
                      <label>{this.props.t("AccountDetails.timezone")}</label>
                      <Dropdown
                        placeholder={this.props.t("AccountDetails.selectTimezone")}
                        fluid
                        selection
                        options={timeZones}
                        onChange={(e, data) => this.handleUpdateTimezone(data.value)}
                        value={this.props.accountDetails.timezone}
                      />
                    </Form.Field>

                    <Form.Field required>
                      <label>
                        {this.props.t("AccountDetails.learningInstitution")}
                      </label>
                      <Dropdown
                        onChange={(e, data) =>
                          this.handleUpdateLearningInstitution(data.value)
                        }
                        placeholder={this.props.t(
                          "AccountDetails.selectLearningInstitution"
                        )}
                        fluid
                        selection
                        options={clients}
                        value={this.props.accountDetails.learningInstitution}
                      />
                    </Form.Field>

                    <Form.Field required>
                      <label>{this.props.t("AccountDetails.province")}</label>
                      <Dropdown
                        onChange={(e, data) => this.handleUpdateProvince(data.value)}
                        placeholder={this.props.t("AccountDetails.selectProvince")}
                        fluid
                        selection
                        options={provinces}
                        value={this.props.accountDetails.province}
                      />
                    </Form.Field>

                    <Form.Field>
                      <label>{this.props.t("AccountDetails.streetAddress")}</label>
                      <input
                        value={this.props.accountDetails.streetAddress || ""}
                        onChange={(e) =>
                          this.handleUpdateStreetAddress(e.target.value)
                        }
                      />
                    </Form.Field>

                    <Form.Group widths="equal">
                      <Form.Input
                        fluid
                        label={this.props.t("AccountDetails.city")}
                        value={this.props.accountDetails.city || ""}
                        onChange={(e) => this.handleUpdateCity(e.target.value)}
                      />
                      <Form.Input
                        fluid
                        label={this.props.t("AccountDetails.postalCode")}
                        value={this.props.accountDetails.postalCode || ""}
                        onChange={(e) => this.handleUpdatePostalCode(e.target.value)}
                      />
                    </Form.Group>
                  </Grid.Column>
                </Grid.Row>
              </Grid>

              <Form.Field required style={{ marginTop: "2em" }}>
                <label>{this.props.t("AccountDetails.personalHeadshot")}</label>
                <div style={{ maxWidth: "600px", margin: "0 auto" }}>
                  <PictureUploader />
                </div>
              </Form.Field>
              <Grid>
                <Grid.Row centered>
                  <Button
                    size="big"
                    color="green"
                    onClick={this.handleSubmit}
                  >
                    {this.props.t("AccountDetails.saveAccountDetails")}
                  </Button>
                  <Button
                    size="big"
                    color="blue"
                    onClick={() => this.props.navigate("/")}
                  >
                    {this.props.t("AccountDetails.backToDashboard")}
                  </Button>
                </Grid.Row>
              </Grid>
            </Form>
          </Segment>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(
  connect(
    (state) => ({
      kc: state.keycloak,
      accountDetails: state.accountDetails,
      clients: state.clients,
    }),
    {
      updateEmailAddress,
      updateFirstName,
      updateLastName,
      updateTimezone,
      updateLearningInstitution,
      updateHideSuccess,
      updateHideError,
      updateProvince,
      addNotification,
      updatePhone,
      updateBirthday,
      updateStreetAddress,
      updatePostalCode,
      updateCity,
      fetchClients,
      updateKeycloak,
    }
  )((props) => {
    const navigate = useNavigate();
    return <AccountDetails {...props} navigate={navigate} />;
  })
);
